"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var abstract_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store"));
var nested_single_select_option_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/nested_single_select_option_store"));
var nested_single_select_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/nested_single_select_input"));
var containsValue = function (value) { return function (option) {
    var _a;
    return (String(option.value) === value || Boolean((_a = option.options) === null || _a === void 0 ? void 0 : _a.some(containsValue(value))));
}; };
var NestedSingleSelectInputStore = /** @class */ (function (_super) {
    __extends(NestedSingleSelectInputStore, _super);
    function NestedSingleSelectInputStore(props) {
        var _this = _super.call(this, props) || this;
        _this.component = nested_single_select_input_1.default;
        _this.handleChange = function (event) {
            var _a, _b;
            (_b = (_a = _this.selectedOptionStore) === null || _a === void 0 ? void 0 : _a.nestedSelectInputStore) === null || _b === void 0 ? void 0 : _b.clear();
            _this._value = event.target.value;
        };
        _this.clear = function () {
            var _a, _b;
            (_b = (_a = _this.selectedOptionStore) === null || _a === void 0 ? void 0 : _a.nestedSelectInputStore) === null || _b === void 0 ? void 0 : _b.clear();
            _this._value = "";
        };
        var options = props.options, selectProps = __rest(props, ["options"]);
        _this.depth = props.depth || 0;
        _this.clearButtonHelpText = props.clearButtonHelpText;
        _this.onChange = props.onChange;
        _this.hidden = options.length === 0;
        _this.optionStores = options.map(function (opt) { return new nested_single_select_option_store_1.default(__assign(__assign({}, opt), { selectProps: __assign(__assign({}, selectProps), { depth: _this.depth + 1 }) })); });
        if (props.defaultValue) {
            var defaultOption = options.find(containsValue(props.defaultValue));
            if (defaultOption) {
                _this.value = defaultOption.value;
            }
        }
        (0, mobx_1.reaction)(function () { return _this.value; }, _this.onChange);
        return _this;
    }
    Object.defineProperty(NestedSingleSelectInputStore.prototype, "active", {
        get: function () {
            var _a;
            return Boolean(this.selectedOptionStore && !((_a = this.selectedOptionStore) === null || _a === void 0 ? void 0 : _a.nestedSelectInputStore));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NestedSingleSelectInputStore.prototype, "value", {
        get: function () {
            var _a, _b;
            return this._value || ((_b = (_a = this.selectedOptionStore) === null || _a === void 0 ? void 0 : _a.nestedSelectInputStore) === null || _b === void 0 ? void 0 : _b.value);
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NestedSingleSelectInputStore.prototype, "selectedOptionStore", {
        get: function () {
            var _this = this;
            return this.optionStores.find(function (opt) { return opt.value === _this._value; });
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], NestedSingleSelectInputStore.prototype, "active", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], NestedSingleSelectInputStore.prototype, "value", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], NestedSingleSelectInputStore.prototype, "selectedOptionStore", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NestedSingleSelectInputStore.prototype, "handleChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NestedSingleSelectInputStore.prototype, "clear", void 0);
    return NestedSingleSelectInputStore;
}(abstract_input_store_1.default));
exports.default = NestedSingleSelectInputStore;
